"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import { BsGraphUp } from "react-icons/bs";
import { FaRegUserCircle } from "react-icons/fa";
import { LuBuilding } from "react-icons/lu";
import type { NavType } from "../../../../core/constants/navigation";
import S from "../index.module.scss";

const NAV_ICONS = {
  "/estates": LuBuilding,
  "/analytics": BsGraphUp,
  "/profile": FaRegUserCircle,
} as const;

const isActiveNav = (pathname: string, href: string) => pathname === href || pathname.startsWith(`${href}/`);

interface HeaderNavProps {
  items: NavType[];
  labels: Record<string, string>;
  profileLabel: string;
}

const HeaderNav = ({ items, labels, profileLabel }: HeaderNavProps) => {
  const pathname = usePathname();

  return (
    <nav className={S.nav} aria-label="Primary navigation">
      {items.map(item => {
        const Icon = item.href in NAV_ICONS ? NAV_ICONS[item.href as keyof typeof NAV_ICONS] : null;
        const isActive = isActiveNav(pathname, item.href);

        return (
          <Link
            key={item.href}
            href={item.href}
            className={clsx(S.navLink, isActive && S.navLinkActive)}
            aria-current={isActive ? "page" : undefined}
          >
            {Icon ? <Icon className={S.navIcon} aria-hidden="true" /> : null}
            <span className={S.navLabel}>{labels[item.href] ?? item.title}</span>
          </Link>
        );
      })}

      <Link
        href="/profile"
        className={clsx(S.navLink, S.mobileProfileLink, isActiveNav(pathname, "/profile") && S.navLinkActive)}
        aria-current={isActiveNav(pathname, "/profile") ? "page" : undefined}
      >
        <FaRegUserCircle className={S.navIcon} aria-hidden="true" />
        <span className={S.navLabel}>{profileLabel}</span>
      </Link>
    </nav>
  );
};

export default HeaderNav;
